<template>
	<v-container fluid class="pa-0 ma-0">
		<div v-if="!loading">
			
			<!--for lg desctop and middle-->
			<div class="hidden-sm-and-down">
				<video-background 
					:src="require('@/assets/video_bg.mp4')"
					:poster="require('@/assets/poster.png')"
					style="max-height: 81.5vh; height: 81.5vh;">
				</video-background>
				
				<v-card class="left">
					<v-row justify="start">
						<v-overlay 
							:absolute="overlay" opacity=".6"
							:z-index="0"
							>
							<h3>{{ 'Business strategy game'| localize }}</h3>
							<!--button sign In -->
							<v-btn color="accent" 
								class="text-lowercase my-4 text--primary"
								dark to="/login">
								{{ 'get started' | localize }}
							</v-btn>
							<h3>{{ 'Business strategy tutorials'| localize }}</h3>
							<v-btn
								color="accent"
								class="text-lowercase mt-4 text--primary"
								target="_blank"
								:href="`/tutorials/UserGuide_${locale.split('-')[0]}.pdf`"
								>{{ 'read' | localize }}
							</v-btn>
						</v-overlay>
					</v-row>
				</v-card>
			</div>
			
			<!--for mobile -->
			<div class="hidden-md-and-up">
				
					<video-background 
						:src="require('@/assets/video_bg.mp4')"
						:poster="require('@/assets/poster.png')"
						style="max-height: 100hv; height: 100vh;">
					</video-background>
				
					<v-card class="all">
						<v-row justify="start">
							<v-overlay 
								:absolute="overlay" opacity=".6"
								:z-index="0"
								>
								<h4>{{ 'Business strategy game' | localize }}</h4>
								<!--button sign In -->
								<v-btn color="accent" 
									class="text-lowercase my-4 text--primary"
									dark to="/login">
									{{ 'get started' | localize }}
								</v-btn>
								<h4>{{ 'Business strategy tutorials' | localize }}</h4>
								<v-btn
									color="accent"
									class="text-lowercase mt-4 text--primary"
									target="_blank"
									:href="`/tutorials/UserGuide_${locale.split('-')[0]}.pdf`"
								>{{ 'read' | localize }}
								</v-btn>
							</v-overlay>
						</v-row>
					</v-card>
			</div>
			
			<!--footer-->
			<v-row class="over hidden-sm-and-down">
				<app-footer></app-footer>
			</v-row>
		</div>
		<div v-else class="text-center">
			<loader />
		</div>
	</v-container>
</template>
<script>
import AppFooter from '@/layouts/AppFooter.vue'
import Loader from '../layouts/Loader.vue'

	export default {

		data () {
			return {
				overlay: true,
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			loggedIn () {
				return this.$store.getters.loggedIn
			},
			locale() {
				return this.$store.getters.locale;
			}
		},
		methods: {
		},
		components: {
			AppFooter,
			Loader
		}
	}
</script>
<style>
	.left { 
		margin-top: -82vh;
		height: 82vh;
		width: 30%;
		text-align: right;
		background-color: transparent !important;
	}
	.all {
		margin-top: -100vh;
		height: 100vh;
		width: 100%;
		text-align: center;
		background-color: transparent !important;
	}
	.over{
		position:relative;
	}
	
</style>